export function splitText() {}
